import React, { Fragment } from "react";
import { connect } from "react-redux";
import { getDriversStats } from "../actions/statsAction";
import Spinner from "../components/layout/Spinner";
import DriverStats from "../components/DriverStats";

class DriversContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getDriversStats();
    // console.log(this.props);
  }
  render() {
    const { loading, driverStats } = this.props.driverStats;
    return (
      <Fragment>
        {loading ? <Spinner /> : <DriverStats driverStats={driverStats} />}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ driverStats }) => ({
  driverStats: driverStats
});
const mapDispatchToProps = dispatch => ({
  getDriversStats: driverStats => dispatch(getDriversStats(driverStats))
});
export default connect(mapStateToProps, mapDispatchToProps)(DriversContainer);
